import React from 'react';
import {DepositWithdrawSection} from "./DepositWithdrawSection";
import {TitleSection} from "./TitleSection";
import {FeesSection} from "./FeesSection";
import {OptimismCapacity} from "../VaultOptimism/components/OptimismCapacity";
import {CrosschainCapacity} from "../Crosschain/components/CrosschainCapacity";
import {useOptimismStableValues} from '../../../contexts/OptimismStableContext'

export function OptimismStableInfo({
 feesData,
 assetsList,
 totalValue,
 profitAndLoss,
 timeLeftToWithdraw,
 isOptimism,
 sttrategyText,
 tvl,
 networkId,
 isBalance,
 title,
}) {
  const {tvlValue} = useOptimismStableValues()

  return (
    <div className="w-full max-w-[470px]">
      <TitleSection
        isStable
        title={title}
        tvlValue={tvl !== undefined ? tvl : tvlValue}
        isOptimism={isOptimism}
        isLowRisk={true}
      />
      <div className="w-full mt-[14px]">
        <p className="text-[14px] leading-[16.8px] text-grey-deep">
          {sttrategyText}
        </p>
      </div>
      <DepositWithdrawSection
        totalValue={totalValue}
        profitAndLoss={profitAndLoss}
        assetsList={assetsList}
        timeLeftToWithdraw={timeLeftToWithdraw}
        isOptimism={isOptimism}
        networkId={networkId}
        isBalance={isBalance}
      />
      {isOptimism && <OptimismCapacity tvlValue={tvl !== undefined ? tvl : tvlValue}/>}
      {!isOptimism && <CrosschainCapacity capacity={tvl}/>}
      <FeesSection feesData={feesData} isOptimism={isOptimism}/>
    </div>
  )
}
